import { Injectable } from '@angular/core';


@Injectable()

export class JwtService {

  getToken(): String {
    return window.localStorage['userToken'];
  }

  saveToken(token: String) {
    window.localStorage['userToken'] = token;
  }

  destroyToken() {
    window.localStorage.removeItem('userToken');
  }

  destroyCookie() {
    this.eraseCookie('msloginuser');
  }

  eraseCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

}
